import React from 'react';
import { Outlet, Link } from "react-router-dom";
import { useListProjectsQuery } from '../api/project';
import { useGetUserQuery } from '../api/user';
import { usePermissions } from '../hooks/usePermissions';
import LoadingSpiner from '../Components/Loader/LoadingSpiner';

export default function Menu(props: any) {

    const { data: projects, isLoading, isError } = useListProjectsQuery({});
    const { data: userData } = useGetUserQuery(undefined);
    const { team } = usePermissions();
    const canManageTeam = team.canManageTeam(userData?.role);
    // const filteredProjects = projects?.filter( (p:any) => p.name.startsWith("DEMO"));
    const filteredProjects = projects ? [...projects].sort((a: any, b: any) => 
        new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
    ) : [];

    return (
        <ul className="sidebar-menu menu text-gray-700 dark:text-white text-md rounded-box p-4">
            <li className="menu-home-item mb-1">
                <Link className='home-link hover:text-gray-500 dark:hover:text-gray-300 focus:text-gray-500 dark:focus:text-gray-300 active:text-gray-600 dark:active:text-white flex items-center' to={"/"}>
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                    </svg>
                    Home
                </Link>
            </li>
            <li className="menu-projects-item mb-1">
                <details open={true} className="projects-dropdown">
                    <summary className="projects-summary flex items-center">
                        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                        </svg>
                        <Link className='projects-link hover:text-gray-500 dark:hover:text-gray-300 focus:text-gray-500 dark:focus:text-gray-300 active:text-gray-600 dark:active:text-white' to={"/projects"}>
                            Projects
                        </Link>
                    </summary>
                    {
                        isLoading && <LoadingSpiner mode="dark"/>
                    }
                    { !isLoading && <ul className='projects-list ml-6 mt-2 space-y-1'>
                        {filteredProjects?.map((project: any, index: number) => {
                            if(index === 4) return <li key={project.id} className="see-all-projects-item"><Link className='see-all-projects-link hover:text-gray-500 dark:hover:text-gray-300 focus:text-gray-500 dark:focus:text-gray-300 active:text-gray-600 dark:active:text-white text-sm' to={`/projects`}>See All</Link></li>
                            if(index >= 5) return null;
                            return <li key={project.id} className="project-menu-item"><Link className='project-menu-link hover:text-gray-500 dark:hover:text-gray-300 focus:text-gray-500 dark:focus:text-gray-300 active:text-gray-600 dark:active:text-white text-sm' to={`/projects/${project.id}`}>{project.name}</Link></li>
                        })}
                    </ul>}
                </details>
            </li>
            <li className="menu-favorites-item mb-1">
                <Link className='favorites-link hover:text-gray-500 dark:hover:text-gray-300 focus:text-gray-500 dark:focus:text-gray-300 active:text-gray-600 dark:active:text-white flex items-center' to="/favorites">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" /></svg>
                    Favorites
                </Link>
            </li>

            {canManageTeam && <li className="menu-members-item mb-1">
                <Link className='members-link hover:text-gray-500 dark:hover:text-gray-300 focus:text-gray-500 dark:focus:text-gray-300 active:text-gray-600 dark:active:text-white flex items-center' to="/members">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
                    Members
                </Link>
            </li>}

            <li className="menu-trash-item mb-1">
                <Link className='trash-link hover:text-gray-500 dark:hover:text-gray-300 focus:text-gray-500 dark:focus:text-gray-300 active:text-gray-600 dark:active:text-white flex items-center' to="/trash">
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        className="w-5 h-5 mr-2"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M3 6H21M8 6V4C8 3.44772 8.44772 3 9 3H15C15.5523 3 16 3.44772 16 4V6M18 6V20C18 20.5304 17.7893 21.0391 17.4142 21.4142C17.0391 21.7893 16.5304 22 16 22H8C7.46957 22 6.96086 21.7893 6.58579 21.4142C6.21071 21.0391 6 20.5304 6 20V6H18ZM10 9V17M14 9V17"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    Trash
                </Link>
            </li>
        </ul>
    )

}